import gql from 'graphql-tag';

export const multiBuildingServiceRequestsQuery = gql`
  query multiBuildingServiceRequestsQuery(
    $channelIds: [UUID!]
    $search: ServiceRequestSearch
    $pagination: PaginationInput!
    $filter: ServiceRequestFilter
  ) {
    multiBuildingServiceRequests(
      channelIds: $channelIds
      search: $search
      pagination: $pagination
      filter: $filter
    ) {
      pageInfo {
        start
        total
        perPage
      }
      serviceRequests {
        serviceRequestId
        createdBy {
          name
          id
        }
        createdAt
        updatedAt
        updatedBy {
          name
          id
        }
        channelId {
          name
          id
        }
        description
        category
        issue
        location
        floor
        company {
          name
          id
        }
        status
        suite
        assignee {
          name
          id
        }
        extRefId
        customQuestions {
          Question
          Answer
        }
        assigneeGroups
        equipment
        isBillable
        friendlyID
        userFriendlyID
        nextStatuses
        violationTime
        taskTimeInMinutes
        scheduledDueDate
        targetResponseDueAt
        effectiveTargetCompletionDueAt
        completionPassFailDeadlineAt
        responseTargetMet
        completionTargetMet
      }
    }
  }
`;
